import './common'
import '../scss/style.scss';

import '~components/slider/slider'
import '~components/product/product'
import '~components/forms/select/select'
import '~components/complect/complect'
import '~components/timer/timer'

//TODO доработать подклдчение скриптов (не подключаются из-за BX)
// import '~components/j-jamilco-catalog/j-jamilco-catalog'
// import '~components/j-product-complect/j-product-complect'
